import { FC, useEffect, useState } from "react";
import "./index.css";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Outlet, Route, Routes } from "react-router-dom";
import { IndexPerfil } from "./index";
import { PerfilInfo } from "./info/info";
import { ResetSenha } from "./resetPassword/reset";
import { Privacy } from "./privacy/privacy";
import { Delete } from "./delete/delete";
import { AddressesIndex } from "./addresses/addressesIndex";
import { UpdateAddress } from "./addresses/createUpdate/UpdateAddress";
import { CreateAddress } from "./addresses/createUpdate/CreateAddress";

import { Menu } from "../../components/Menu";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";

const PerfilLayout: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pluginspace_id, id_address } = useParams();

  const { getAppConfig } = useAppConfig();
  const [config, setConfig] = useState<ConfigType | void>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      setLoading(true);
      try {
        const conf = await getAppConfig();
        setConfig(conf);
      } catch (error) {
        console.error("Erro ao buscar config", error);
      }
      setLoading(false);
    };
    fetchConfig();
  }, []);

  const toNavigate = () => {
    const path = location.pathname.split("/");
    const pathLength = path.length > 0 ? path.length - 1 : 0;

    if (
      path[pathLength] === "addresses" ||
      path[pathLength] === "privacy" ||
      path[pathLength] === "info" ||
      path[pathLength] === "new_password"
    ) {
      navigate(`/${pluginspace_id}/profile`);
    } else if (
      path[pathLength] === id_address ||
      path[pathLength] === "create"
    ) {
      navigate(`/${pluginspace_id}/profile/addresses`);
    } else if (path[pathLength] === "delete") {
      navigate(`/${pluginspace_id}/profile/privacy`);
    } else {
      navigate(`/${pluginspace_id}/category`);
    }
  };

  const primaryColor = config?.webappcolor?.webappbutton || "#078BD8";

  return (
    <div className="perfil-wrapper">
      <div className="content-perfil">
        {loading ? (
          <div className="loading-container">
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            {/* O Container de Rolagem agora abriga o botão Voltar e o Outlet */}
            <div className="perfil-outlet-container">
              <button className="btn-back-perfil" onClick={() => toNavigate()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
                Voltar
              </button>

              <Outlet />
            </div>

            <Menu
              activeMenu="info"
              fontColor={config?.webappcolor.iconsfooter || "#636363"}
              activeFontColor={config?.webappcolor.highlightfooter || "#000"}
              backgroundMenu={config?.webappcolor.backgroundfooter || "#F5F5F5"}
              colorIcons={config?.webappcolor.iconsfooter || "#636363"}
              highlightColorIcons={
                config?.webappcolor.highlightfooter || "#636363"
              }
              backgroundCart={config?.webappcolor.backgroundcart || "#FFBA49"}
              fontCart={config?.webappcolor.fontcart || "#000"}
              noSales={config?.content?.pdv?.noSales || false}
            />
          </>
        )}
      </div>
    </div>
  );
};

const PerfilPage = () => (
  <Routes>
    <Route element={<PerfilLayout />}>
      <Route path="profile" element={<IndexPerfil />} />
      <Route path="info" element={<PerfilInfo />} />
      <Route path="new_password" element={<ResetSenha />} />
      <Route path="privacy" element={<Privacy />} />
      <Route path="privacy/delete" element={<Delete />} />
      <Route path="addresses" element={<AddressesIndex />} />
      <Route path="addresses/create" element={<CreateAddress />} />
      <Route path="addresses/:id_address" element={<UpdateAddress />} />
      <Route index element={<IndexPerfil />} />
    </Route>
  </Routes>
);

export { PerfilPage };
